module.exports = __webpack_public_path__ + "static/img/risk_sp3.a1b26632.png";